import AppErrorBoundary from "shared/components/ErrorBoundary";
import { GlobalProvider, Flex } from "@enaep-ng/benchmark";
import { AspectRatioBox } from "@enaep-ng/benchmark-lab";
import { LoadingView } from "shared/views";
import { useDedupEffect } from "shared/hooks/useDedupEffect";
import { useMaintenanceCheck } from "shared/hooks/useMaintenanceCheck";
import { environment } from "shared/util";
import { useState } from "react";
import App from "./App";
function AppResolver() {
  const {isUnderMaintenance} = useMaintenanceCheck(`${environment.resovleAppDomain()}maintenance/maintenance.html`);
  const [loadApp,setLoadApp] = useState(false);
  useDedupEffect(()=>{
    isUnderMaintenance().then((status)=>{
        if(!status){
          setLoadApp(true);
        }
    });
  },[])
  return (
    <>
    {loadApp && <App/>}
    {!loadApp  && <GlobalProvider>
      <Flex
        sx={{
          height: "calc(100vh * var(--zoom))",
          minHeight: 0,
          flexDirection: "column",
          overflow: "hidden",
          alignItems: "center",
        }}
      >
        <AspectRatioBox
          targetWidth={1366}
          targetHeight={768}
          style={{
            overflow: "hidden",
          }}
          fluid={true}
        >
          <AppErrorBoundary hasError={false}>
          <LoadingView />
          </AppErrorBoundary>
        </AspectRatioBox>
      </Flex>
    </GlobalProvider>}
    </>
  );
}

export default AppResolver;


